import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import gsap from 'gsap';

export default function ITServices() {
    const navigate = useNavigate();
    const containerRef = useRef();
    const paragraphRef = useRef(null);
    const listRef = useRef([]);

    const listItems = [
        'Assist you with hardware installation and upgrades',
        'Diagnosing computers that are slow or crashing',
        'Build computer systems',
        'Security audit',
        'We offer recyling for your electronics whether working or broken',
    ];

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.from(paragraphRef.current, {
                x: -50,
                opacity: 0,
                duration: 0.5,
                ease: 'power2.out',
                delay: 0.3,
            });

            gsap.from(listRef.current, {
                x: -50,
                opacity: 0,
                duration: 0.5,
                ease: 'power2.out',
                stagger: 0.2,
                delay: 0.6,
            });
        }, containerRef);

        return () => ctx.revert(); // Clean up on unmount
    }, []);

    return (
        <div className="space-y-4" ref={containerRef}>
            <button
                onClick={() => navigate(-1)}
                className="text-sm text-blue-600 hover:underline"
            >
                ← Back to Services
            </button>

            <section className="p-6 border rounded-lg bg-gray-50 dark:bg-gray-800">
                <h2 className="text-2xl font-semibold mb-2">IT Services</h2>

                <div>
                    <p ref={paragraphRef} className="p-6">
                        We provide time-sensetive, professional, and friendly IT support to business located in and around Ottawa
                    </p>

                    <ul className="list-disc pl-6 space-y-2">
                        {listItems.map((item, index) => (
                            <li
                                key={index}
                                ref={(el) => (listRef.current[index] = el)}
                            >
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        </div>
    );
}
